import axios from 'axios'
import VueCookie from 'vue-cookie'

const authInterceptor = (config) => {
  /* a request that sets its own Authorization header wins. Interceptors run
     as microtasks, after the caller's synchronous code — logout deletes the
     token cookie in that window, so it must pin the header itself or the
     request goes out unauthenticated */
  if (config.headers && config.headers.Authorization) return config
  const token = VueCookie.get(process.env.VUE_APP_TOKEN)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  } else {
    delete config.headers.Authorization
  }
  return config
}
const api = axios.create({
  baseURL: process.env.VUE_APP_URL
})
api.interceptors.request.use(authInterceptor)

const checklistApi = axios.create({
  baseURL: process.env.VUE_APP_CHECKLIST_URL,
  headers: {
    common: {
      'X-AccessToken': VueCookie.get(process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN),
      'x-auth-token': process.env.VUE_APP_CHECKLIST_AUTH_TOKEN ?? ''
    }
  }
})

const hostAppApi = axios.create({
  responseType: 'json'
})
hostAppApi.interceptors.request.use(authInterceptor)

// eslint-disable-next-line
const documentUrl = process.env.VUE_APP_DOCUMENT_URL
// eslint-disable-next-line
export { api, checklistApi, documentUrl, hostAppApi }
